var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64286 30C4.3192 30 0 25.6808 0 20.3571C0 16.1518 2.69196 12.5759 6.44196 11.2567C6.43527 11.0759 6.42857 10.8951 6.42857 10.7143C6.42857 4.79464 11.2232 0 17.1429 0C21.1138 0 24.5759 2.15625 26.4308 5.37054C27.4487 4.6875 28.6808 4.28571 30 4.28571C33.5491 4.28571 36.4286 7.16518 36.4286 10.7143C36.4286 11.5312 36.2746 12.308 36 13.0312C39.9107 13.8214 42.8571 17.2835 42.8571 21.4286C42.8571 26.1629 39.0201 30 34.2857 30H9.64286ZM14.933 15.4687C14.3036 16.0982 14.3036 17.1161 14.933 17.7388C15.5625 18.3616 16.5804 18.3683 17.2031 17.7388L19.8147 15.1272L19.8214 24.1071C19.8214 24.9978 20.5379 25.7143 21.4286 25.7143C22.3192 25.7143 23.0357 24.9978 23.0357 24.1071V15.1272L25.6473 17.7388C26.2768 18.3683 27.2946 18.3683 27.9174 17.7388C28.5402 17.1094 28.5469 16.0915 27.9174 15.4687L22.5603 10.1116C21.9308 9.48214 20.9129 9.48214 20.2902 10.1116L14.933 15.4687Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.0da737af8952012ae7a30dbfee813773.svg";
export { ForwardRef as ReactComponent };